module.exports = __webpack_public_path__ + "img/frame-6.422585a6.png";